<script setup lang="ts">
import { Type } from '../../utility';
import MetricBreakdownSection from './MetricBreakdownSection.vue';

defineProps<{
  inPopup?: boolean;
}>();
</script>
<template>
  <div
    :class="{
      'grid items-center row-gap[2]': !inPopup,
      'flex flex-row flex-wrap justify-between': inPopup,
    }"
  >
    <MetricBreakdownSection :type="Type.Positive" :in-popup="inPopup"></MetricBreakdownSection>
    <MetricBreakdownSection :type="Type.Neutral" :in-popup="inPopup"></MetricBreakdownSection>
    <MetricBreakdownSection :type="Type.Negative" :in-popup="inPopup"></MetricBreakdownSection>
  </div>
</template>
